import axios from 'axios';
import { getAuthToken, removeAuthToken } from './helpers';
import showMessage from 'providers/NoticeProvider/showMessage';
import { ROUTES } from 'routes';

const $api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    // paramsSerializer: {
    //     // @ts-ignore
    //     encode: param => encodeURI(param).replaceAll(':', '%3A'),
    // },
});

$api.interceptors.request.use(config => {
    const authToken = getAuthToken();
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    // config.headers['Content-Type'] = 'application/json';
    // config.headers['X-Application-Forwarded-Client-User-Agent'] = window.navigator.userAgent;
    // config.headers['X-Application-API-Private-Key'] = process.env.REACT_APP_X_APPLICATION_API_PRIVATE_KEY;
    // config.headers['X-Application-API-Public-Key'] = process.env.REACT_APP_X_APPLICATION_API_PUBLIC_KEY;
    return config;
});

$api.interceptors.response.use(
    config => {
        return config;
    },
    async error => {
        showMessage(error.response.data.message, 'error');
        if (error.response.status === 401) {
            removeAuthToken();
            if (window.location.pathname !== ROUTES.sign_out.fullPath) {
                // @ts-ignore
                window.location = ROUTES.sign_out.fullPath;
            }
        }
        // if (
        //     error.response.status === 404 &&
        //     error.response.data.message !== 'Promotional Code not found.' &&
        //     !error.response.data.message.includes('Payment method')
        // ) {
        //     // @ts-ignore
        //     window.location = ROUTES[404];
        // }
        return Promise.reject(error);
    },
);

export default $api;
